import { useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

export default function Auth({ formType }) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const formTitle = formType === "login" ? "Welcome back" : "Create an account";
  const buttonText =
    formType === "login" ? "Sign in to your account" : "Sign up";
  const linkText =
    formType === "login"
      ? "Don't have an account?"
      : "Already have an account?";
  const linkHref = formType === "login" ? "/auth/register" : "/auth/login";

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Sol Sütun */}
      <div className="w-full md:w-1/2 bg-gray-100 flex flex-col items-center justify-center p-10">
        {/* Şirket logosu ekleyebiliriz veya sütunun komple arkaplanı resim yapabiliriz */}
        <div className="mb-6">
          <div className="w-24 h-24 bg-gray-400 rounded-full flex items-center justify-center text-white text-2xl">
            Logo
          </div>
        </div>

        <h1 className="text-3xl font-bold mb-4">Welcome to FinAI</h1>
        {/* motto - slogan vs tarzında düşündüm buraları düzenlerken */}
        <p className="text-gray-600 mb-2">
          Manage your account easily and securely.
        </p>
        <p className="text-gray-600">Join us and make your life easier.</p>
      </div>

      {/* Sağ Sütun */}
      <div className="w-full md:w-1/2 flex flex-col justify-center items-center p-10">
        {/* Form Başlığı */}
        <h2 className="text-2xl font-bold mb-6">{formTitle}</h2>

        {/* Social Login */}
        <div className="flex space-x-4 mb-6">
          {/* Apple */}
          <button
            type="button"
            className="text-white bg-[#050708] hover:bg-[#050708]/80 focus:ring-4 focus:outline-none focus:ring-[#050708]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 dark:bg-gray-800"
          >
            <svg
              className="w-5 h-5 me-2 -ms-1"
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="apple"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path
                fill="currentColor"
                d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
              ></path>
            </svg>
            Sign up with Apple
          </button>

          {/* Google */}
          <button
            type="button"
            className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700"
          >
            <svg
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 me-2 -ms-1"
            >
              <path
                d="M30.0014 16.3109C30.0014 15.1598 29.9061 14.3198 29.6998 13.4487H16.2871V18.6442H24.1601C24.0014 19.9354 23.1442 21.8798 21.2394 23.1864L21.2127 23.3604L25.4536 26.58L25.7474 26.6087C28.4458 24.1665 30.0014 20.5731 30.0014 16.3109Z"
                fill="#4285F4"
              ></path>
              <path
                d="M16.2863 29.9998C20.1434 29.9998 23.3814 28.7553 25.7466 26.6086L21.2386 23.1863C20.0323 24.0108 18.4132 24.5863 16.2863 24.5863C12.5086 24.5863 9.30225 22.1441 8.15929 18.7686L7.99176 18.7825L3.58208 22.127L3.52441 22.2841C5.87359 26.8574 10.699 29.9998 16.2863 29.9998Z"
                fill="#34A853"
              ></path>
              <path
                d="M8.15964 18.769C7.85806 17.8979 7.68352 16.9645 7.68352 16.0001C7.68352 15.0356 7.85806 14.1023 8.14377 13.2312L8.13578 13.0456L3.67083 9.64746L3.52475 9.71556C2.55654 11.6134 2.00098 13.7445 2.00098 16.0001C2.00098 18.2556 2.55654 20.3867 3.52475 22.2845L8.15964 18.769Z"
                fill="#FBBC05"
              ></path>
              <path
                d="M16.2864 7.4133C18.9689 7.4133 20.7784 8.54885 21.8102 9.4978L25.8419 5.64C23.3658 3.38445 20.1435 2 16.2864 2C10.699 2 5.8736 5.1422 3.52441 9.71549L8.14345 13.2311C9.30229 9.85555 12.5086 7.4133 16.2864 7.4133Z"
                fill="#EB4335"
              ></path>
            </svg>
            Sign up with Google
          </button>
        </div>

        <div className="flex items-center w-full mb-6">
          <div className="flex-grow border-t border-gray-300"></div>
          <span className="mx-4 text-gray-500">or</span>
          <div className="flex-grow border-t border-gray-300"></div>
        </div>

        {/* Form */}
        <form className="w-full max-w-md space-y-4">
          {/* Name and Surname only for Register form*/}
          {formType === "register" && (
            <>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="block text-sm text-gray-700">
                    First Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="John"
                    required
                    className="w-full mt-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                  />
                </div>
                <div>
                  <label
                    htmlFor="surname"
                    className="block text-sm text-gray-700"
                  >
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="surname"
                    id="surname"
                    placeholder="Doe"
                    required
                    className="w-full mt-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                  />
                </div>
              </div>
            </>
          )}

          {/* Username area */}
          {formType === "register" && (
            <div>
              <label htmlFor="username" className="block text-sm text-gray-700">
                Username
              </label>
              <input
                type="text"
                name="username"
                id="username"
                placeholder="johndoe1"
                required
                className="w-full mt-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
              />
            </div>
          )}
          {/* Email */}
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="you@example.com"
              required
              className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-700 placeholder:text-gray-400 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-indigo-600"
            />
          </div>
          {/* Password area*/}
          <div>
            <label htmlFor="password" className="block text-sm text-gray-700">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                id="password"
                placeholder="••••••••"
                required
                className="w-full mt-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 flex items-center px-2"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <EyeIcon className="h-5 w-5 text-gray-500" />
                ) : (
                  <EyeSlashIcon className="h-5 w-5 text-gray-500" />
                )}
              </button>
            </div>
          </div>

          {/* Confirm Password only for Register form */}
          {formType === "register" && (
            <div>
              <label
                htmlFor="confirmPassword"
                className="block text-sm text-gray-700"
              >
                Confirm Password
              </label>
              <div className="relative">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  id="confirmPassword"
                  placeholder="••••••••"
                  required
                  className="w-full mt-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 flex items-center px-2"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <EyeIcon className="h-5 w-5 text-gray-500" />
                  ) : (
                    <EyeSlashIcon className="h-5 w-5 text-gray-500" />
                  )}
                </button>
              </div>
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full rounded-lg bg-indigo-600 py-2 text-white font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-400"
          >
            {buttonText}
          </button>
        </form>

        {/* Signup/Login Link */}
        <p className="text-sm text-center text-gray-500 mt-4">
          {linkText}{" "}
          <a href={linkHref} className="text-indigo-600 hover:text-indigo-800">
            {formType === "login" ? "Create an account" : "Login"}
          </a>
        </p>
      </div>
    </div>
  );
}
